import React, { useCallback, useEffect, useRef, useState } from "react";
import { IoClose } from "react-icons/io5";
import { Select, Tag } from "antd";
import "antd/dist/reset.css";
import { toast } from "react-hot-toast";
import axios from "../../API/axios";
import { refreshSyncAccountAlgoData } from "../../Services/apiService";
import { prependNewsFeedPost } from "../../utility/newsFeedPost";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { privacySelectStyles } from "../../selectStyles";
import SelectPrivacy from "react-select";
import EditSharpIcon from "@mui/icons-material/EditSharp";

import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import PublicSharpIcon from "@mui/icons-material/PublicSharp";
import GroupSharpIcon from "@mui/icons-material/GroupSharp";
import LockSharpIcon from "@mui/icons-material/LockSharp";
import TuneSharpIcon from "@mui/icons-material/TuneSharp";
import useEscapeKeyDown from "../../hooks/useEscapeKeyDown";
import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  Crop,
  PixelCrop,
  convertToPixelCrop,
} from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import parse from "html-react-parser";
import Delta from "quill-delta";
import Quill from 'quill';
import "quill/dist/quill.snow.css";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
// import Cropper from "react-easy-crop";
import { reset } from "linkifyjs";
import { useTranslation } from "react-i18next";
import { Portal } from "../../components/Portal";


// Utility function for creating image from URL
const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", (error) => reject(error));
    image.setAttribute("crossOrigin", "anonymous");
    image.src = url;
  });

// Convert degrees to radians
function getRadianAngle(degreeValue) {
  return (degreeValue * Math.PI) / 180;
}

// Function to get cropped image
async function getCroppedImg(imageSrc, pixelCrop, rotation = 0) {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  const maxSize = Math.max(image.width, image.height);
  const safeArea = 2 * ((maxSize / 2) * Math.sqrt(2));

  // Set canvas dimensions
  canvas.width = safeArea;
  canvas.height = safeArea;

  // Translate canvas context for rotation
  ctx.translate(safeArea / 2, safeArea / 2);
  ctx.rotate(getRadianAngle(rotation));
  ctx.translate(-safeArea / 2, -safeArea / 2);

  // Draw rotated image
  ctx.drawImage(
    image,
    safeArea / 2 - image.width * 0.5,
    safeArea / 2 - image.height * 0.5
  );
  const data = ctx.getImageData(0, 0, safeArea, safeArea);

  // Set canvas to final crop size
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;

  // Place image data at correct position
  ctx.putImageData(
    data,
    Math.round(0 - safeArea / 2 + image.width * 0.5 - pixelCrop.x),
    Math.round(0 - safeArea / 2 + image.height * 0.5 - pixelCrop.y)
  );

  // Return as a blob URL
  return new Promise((resolve) => {
    canvas.toBlob((file) => {
      resolve(URL.createObjectURL(file));
    }, "image/jpeg");
  });
}


const AddArticle = ({ showModal, closeModal, setPostList, restrictedViewerToken }) => {
  const [title, setTitle] = useState("");
  const [tags, setTags] = useState([]);
  const language = localStorage.getItem("Lang");
  useEscapeKeyDown(showModal, closeModal);

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.body.classList.add("modal-open");
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "";
      document.body.classList.remove("modal-open");
    }
  }, [showModal]);

  // const tagOptions = ["React", "Mongo", "Express", "Node"];

  // Selected tags state
  // const [selectedTags, setSelectedTags] = useState([]);

  // Handle tag change
  // const handleTagChange = (values) => {
  //   setSelectedTags(values);
  // };

  //Tags
  const { t } = useTranslation();

  const [tagOptions, setTagOptions] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);

  useEffect(() => {
    const fetchTags = async () => {
      try {
        const response = await axios.get("/Posts/GetArticleTagsList");
         setTagOptions(response?.data?.responseData);
          
      } catch (error) {
        console.error("Failed to fetch tag options:", error);
      }
    };

    fetchTags();
  }, []);

  const handleTagChange = (values) => {
    setSelectedTags(values);
  };

  //Tag Closed

  //Rich Text Editor
  const editorRef = useRef(null);

  const toolbarOptions = [
    ["bold", "italic", "underline", "strike"],
    ["blockquote", "code-block"],
    ["link", "image"],
    [{ header: 1 }, { header: 2 }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ script: "sub" }, { script: "super" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ direction: "rtl" }],
    [{ size: ["small", false, "large", "huge"] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }, { background: [] }],
    [{ font: [] }],
    [{ align: [] }],
    ["clean"],
  ];

  const modules = {
    toolbar: toolbarOptions,
    clipboard: {
      matchVisual: true,
    },
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "script",
    "link",
    "image",
    "code-block",
    "color",
    "background",
    "align",
    "direction",
  ];

  //Rich text editor closed

  //Add article
  const sessionId = localStorage.getItem("sessionId");

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const [display, setDisplay] = useState(false);
  const [isloading, setIsloading] = useState(false);

  const [images, setImages] = useState([]);
  const [postInputValue, setPostInputValue] = useState("");
  const [postDynamicValues, setPostDynamicValues] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [mentionType, setMentionType] = useState("");
  const [query, setQuery] = useState("");
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [cursorPosition, setCursorPosition] = useState(0);
  const userUid = localStorage.getItem("userUid");
  const [description, setDescription] = useState("");
  const [SearchText, setSearchText] = useState("")

  const handleArticleChange = (content, delta, source, editor) => {
    const value = editor.getText(); // plain text, better than content HTML
    const caret = editor.getSelection()?.index || 0;

    setDescription(content); // still keep full HTML
    setCursorPosition(caret);
    detectTrigger(value, caret);

    // Filter out dynamic values no longer in content
    const updatedDynamicValues = postDynamicValues?.filter(
      ({ type, display }) => {
        const prefix = type === "UserMention" ? "@" : "#";
        const fullMention = `${prefix}${display}`;
        return value.includes(fullMention);
      }
    );

    // Reassign dVno after filtering to keep {1}, {2}, ... in correct order
    const reassignedDynamicValues = updatedDynamicValues.map((item, index) => ({
      ...item,
      dVno: index + 1,
    }));

    setPostDynamicValues(reassignedDynamicValues);

    // Recompute postInputValue
    const quillInstance = editorRef.current?.getEditor?.();
    const htmlContent = quillInstance?.root?.innerHTML || "";

    const updatedPostInputValue = updatePostInputValueWithDynamicValues(
      htmlContent,
      reassignedDynamicValues
    );

    setPostInputValue(updatedPostInputValue);
  };

  const updatePostInputValueWithDynamicValues = (rawContent, dynamicValues) => {
    let modifiedText = rawContent;

    dynamicValues.forEach(({ type, dVno, display }) => {
      const prefix = type === "UserMention" ? "@" : "#";
      const fullMention = `${prefix}${display}`;
      const regex = new RegExp(escapeRegex(fullMention) + "(?!\\S)", "g");
      modifiedText = modifiedText.replace(regex, `{${dVno}}`);
    });

    return modifiedText.trim();
  };

  // Detect @ or #
  const detectTrigger = (value, caret) => {
    const textBeforeCursor = value.slice(0, caret);
    const match = textBeforeCursor.match(/([@#])(\w*)$/);
    if (match) {
      const trigger = match[1];
      const q = match[2];
      setMentionType(trigger === "@" ? "UserMention" : "Hashtag");
      setQuery(q);
      fetchSuggestions(q, trigger);
      setSearchText(q)
    } else {
      // setShowSuggestions(false);
      setSearchText('')
    }
  };

  const fetchSuggestions = async (searchText, triggerChar) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
    };

    try {
      if (triggerChar === "@") {
        const res = await axios.post(
          `General/MentionTagDDL?Search=${searchText}`,
          data
        );
        const results = res.data.responseData || [];
        setSuggestions(results);
        setShowSuggestions(results.length > 0);
      } else if (triggerChar === "#") {
        const res = await axios.post(
          `General/HashtagDDL?SearchHashtag=${searchText}`,
          data
        );
        const results = res.data.responseData || [];
        setSuggestions(results);
        setShowSuggestions(results.length > 0);
      }
    } catch (err) {
      console.error(err);
      if (triggerChar === "#" && searchText) {
        setShowSuggestions(true);
      } else {
        setShowSuggestions(false);
      }
    }
  };

  const insertMention = (suggestion, userUid) => {
    const quill = editorRef.current?.getEditor?.();
    if (!quill) return;

    const cursorPosition = quill.getSelection()?.index || 0;
    const textBeforeCursor = quill.getText(0, cursorPosition);
    const match = textBeforeCursor.match(/[@#]\w*$/);
    if (!match) return;

    const startIndex = cursorPosition - match[0].length;
    const mentionPrefix = mentionType === "UserMention" ? "@" : "#";
    const displayName = suggestion;
    const mentionText = `${mentionPrefix}${displayName} `;

    // Replace partial mention with full one
    quill.deleteText(startIndex, match[0].length);
    quill.insertText(startIndex, mentionText);
    quill.setSelection(startIndex + mentionText.length);

    // Update dynamic values
    const safePostDynamicValues = Array.isArray(postDynamicValues)
      ? postDynamicValues
      : [];
    const dVno = safePostDynamicValues.length + 1;

    const updatedPostDynamicValues = [
      ...safePostDynamicValues,
      {
        type: mentionType,
        dVno,
        entity: mentionType === "UserMention" ? userUid : suggestion,
        display: displayName,
      },
    ];
    setPostDynamicValues(updatedPostDynamicValues);

    const editorHtml = quill.root.innerHTML;
    const updatedInputValue = updatePostInputValueWithDynamicValues(
      editorHtml,
      updatedPostDynamicValues
    );
    setPostInputValue(updatedInputValue);
    setShowSuggestions(false);
    setSearchText('')
  };

  // Helper: Escape regex special characters
  const escapeRegex = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };

  // Validate title - only allow alphanumeric characters and spaces, no double spaces
  const handleTitleChange = (e) => {
    const value = e.target.value;
    // Allow only letters, numbers, and spaces
    let validatedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
    // Remove multiple consecutive spaces and replace with single space
    validatedValue = validatedValue.replace(/\s+/g, " ");
    setTitle(validatedValue);
  };

  const [privacyType, setPrivacyType] = useState("Public");
  const Privacy = [
    { value: "Public", label: t("Newsfeed.Public"), icon: <PublicSharpIcon /> },
    { value: "Friends", label: t("Newsfeed.Friends"), icon: <GroupSharpIcon /> },
    { value: "OnlyMe", label: t("Newsfeed.OnlyMe"), icon: <LockSharpIcon /> },
    { value: "Custom", label: t("Newsfeed.Custom"), icon: <TuneSharpIcon /> },
  ];

  // const handleSubmit = async () => {

  //   setIsloading(true);
  //   try {

  //     setDisplay(true);
  //     const formData = new FormData();
  //     formData.append("DeviceType", "Web");
  //     formData.append("sessionId", sessionId);
  //     formData.append("PrivacyType", privacyType || "Public");
  //     formData.append("PostOriginType", "User");
  //     formData.append("BannerFile", bannerImage);
  //     formData.append("PostOriginID", userUid);
  //     formData.append("PostCategory", "Article");
  //     formData.append("Title", title);
  //     formData.append(
  //       "PostContent",
  //       postInputValue ? postInputValue : description
  //     );
  //     formData.append("Tags", selectedTags);
  //     formData.append("DynamicValues", JSON.stringify(postDynamicValues));
  //     const res = await axios.post("/Posts/CreateArticle", formData, {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //       },
  //     });
  //     setShowToast(true);
  //     setToastMessage(res?.data?.message || "Article created successfully");
  //     const newPostId = res?.data?.responseData?.id;
  //     const postDetailsResponse = await axios.get(
  //       `/Posts/GetPostInfo?DeviceType=Web&PostId=${newPostId}&RestrictedViewerToken=${restrictedViewerToken}`
  //     );
  //     const newPost = postDetailsResponse?.data?.responseData.postInfo;
  //     console.log("newPostnewPost", newPost);

  //     setPostList((prev) => [newPost, ...prev]);

  //     setTitle("");
  //     setBannerImage(null);
  //     setDescription("");
  //     setSelectedTags([]);
  //     setPostInputValue("");
  //     setPostDynamicValues([]);
  //     closeModal();

  //     setIsloading(false);
  //     setPostDynamicValues([]);
  //     setPostInputValue("");
  //   } catch (error) {
  //     console.log("newPostId", error);
  //     if (error.response || error.response.status === 404 || error.response.status === 400) {
  //       setWarningToastMessage(error.response.data.title);
  //       setShowWarningToast(true);
  //     } else {
  //       setErrorToastMessage(error.response.data.title);
  //       setShowErrorToast(true);
  //     }
  //     setIsloading(false);
  //   }

  // };

  //Image crop

  const reset = () => {
    setDisplay(false);

    setTitle("");
    setBannerImage(null);
    setDescription("");
    setSelectedTags([]);
    setPostInputValue("");
    setPostDynamicValues([]);

  }

  const handleSubmit = async (e) => {
    setDisplay(true);

    if (e) e.preventDefault();

    if (!bannerImage) {
      setWarningToastMessage(t("Newsfeed.Please upload a banner image"));
      setShowWarningToast(true);
      return;
    }

    if (
      // !bannerImage &&
      title.trim() === "" &&
      selectedTags === "" &&
      postInputValue.trim() === "" ||
      description.trim() === ''
    ) {
      setWarningToastMessage(t("modals.Please fill all the required fields"));
      setShowWarningToast(true);
      return; // stop execution if validation fails
    }

    setIsloading(true);
    try {

      const formData = new FormData();
      formData.append("DeviceType", "Web");
      formData.append("sessionId", sessionId);
      formData.append("PrivacyType", privacyType || "Public");
      formData.append("PostOriginType", "User");
      formData.append("BannerFile", bannerImage);
      formData.append("PostOriginID", userUid);
      formData.append("PostCategory", "Article");
      formData.append("Title", title);
      formData.append("PostContent", postInputValue || description);
      // formData.append("Tags", selectedTags);  
      formData.append("Tags", JSON.stringify(selectedTags));
      formData.append("langKey", language === "en" ? "" : language,);



      formData.append("DynamicValues", JSON.stringify(postDynamicValues));

      const res = await axios.post("/Posts/CreateArticle", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setShowToast(true);
      setToastMessage(res?.data?.message || "Article created successfully");

      const newPostId = res?.data?.responseData?.id;
      const postDetailsResponse = await axios.get(
        `/Posts/GetPostInfo?DeviceType=Web&PostId=${newPostId}&RestrictedViewerToken=${restrictedViewerToken}&langKey=${language}`
      );

      const newPost = postDetailsResponse?.data?.responseData?.postInfo;
      console.log("newPostnewPost", newPost);

      setPostList((prev) => prependNewsFeedPost(prev, newPost));
      refreshSyncAccountAlgoData().catch(() => {});

      // ✅ Reset fields after success
      reset();
      // setDisplay(false);

      // setTitle("");
      // setBannerImage(null);
      // setDescription("");
      // setSelectedTags([]);
      // setPostInputValue("");
      // setPostDynamicValues([]);

      closeModal();
      setIsloading(false);
    } catch (error) {
      console.log("newPostId", error);

      if (error.response && (error.response.status === 404 || error.response.status === 400)) {
        setWarningToastMessage(error.response.data.message || error.response.data.title);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error?.response?.data?.message);
        setShowErrorToast(true);
      }
      setIsloading(false);
    }
  };


  const CROP_RESOLUTIONS = [
    { id: "1920x1080", label: "1920 × 1080", width: 1920, height: 1080 },
    { id: "1280x720", label: "1280 × 720", width: 1280, height: 720 },
    { id: "800x450", label: "800 × 450", width: 800, height: 450 },
    { id: "original", label: "Original", width: null, height: null },
  ];

  const [bannerImage, setBannerImage] = useState(null);
  const [showCropper, setShowCropper] = useState(false);
  const [imagePreview, setImagePreview] = useState(null); // cropped preview after Apply
  const [originalBannerUrl, setOriginalBannerUrl] = useState(null); // original upload for re-crop
  const [cropper, setCropper] = useState(null);
  const [cropperKey, setCropperKey] = useState(0);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [rotation, setRotation] = useState(0);
  const [showCropSettings, setShowCropSettings] = useState(false);
  const [cropMode, setCropMode] = useState("fixed"); // fixed | auto
  const [cropResolutionId, setCropResolutionId] = useState("1920x1080");

  const [extraImages, setExtraImages] = useState([]);
  const [activeCropIndex, setActiveCropIndex] = useState(null); // which extra image to crop
  const [extraCroppedAreaPixels, setExtraCroppedAreaPixels] = useState(null);

  useEffect(() => {
    if (!cropper) return;
    cropper.setAspectRatio(cropMode === "fixed" ? 16 / 9 : NaN);
  }, [cropMode, cropper]);

  const revokeIfBlobUrl = (url) => {
    if (url && typeof url === "string" && url.startsWith("blob:")) {
      try {
        URL.revokeObjectURL(url);
      } catch (e) {}
    }
  };

  // Re-open cropper with the original uploaded image
  const openBannerCropper = () => {
    if (!originalBannerUrl && !(bannerImage instanceof Blob)) return;
    setCropper(null);
    setShowCropSettings(false);
    setCropperKey((key) => key + 1);
    setShowCropper(true);
  };



  // Handle file selection
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const imageUrl = URL.createObjectURL(file);
      setOriginalBannerUrl((prev) => {
        if (prev && prev !== imagePreview) revokeIfBlobUrl(prev);
        return imageUrl;
      });
      setImagePreview((prev) => {
        if (prev && prev !== imageUrl) revokeIfBlobUrl(prev);
        return imageUrl;
      });
      setBannerImage(file);
      setCropper(null);
      setShowCropSettings(false);
      setCropperKey((key) => key + 1);
      setShowCropper(true);
    }
  };

  const handleAddNewImage = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const imageUrl = URL.createObjectURL(file);

      // Add to array
      setExtraImages((prev) => [...prev, { file, url: imageUrl }]);
    }
  };


  // When crop is completed
  // const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
  //   setCroppedAreaPixels(croppedAreaPixels);
  // }, []);
  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    if (activeCropIndex !== null) {
      setExtraCroppedAreaPixels(croppedAreaPixels);
    } else {
      setCroppedAreaPixels(croppedAreaPixels); // old main image logic
    }
  }, [activeCropIndex]);


  // Apply crop and save image
  // const saveCroppedImage = async () => {
  //   try {
  //     const croppedImageUrl = await getCroppedImg(
  //       imagePreview,
  //       croppedAreaPixels,
  //       rotation
  //     );

  //     // Convert blob URL to File object
  //     const response = await fetch(croppedImageUrl);
  //     const blob = await response.blob();
  //     const file = new File([blob], "cropped-image.jpg", {
  //       type: "image/jpeg",
  //     });

  //     setBannerImage(file);
  //     setImagePreview(croppedImageUrl); // show cropped version
  //     setShowCropper(false);
  //   } catch (e) {
  //     console.error("Error cropping image:", e);
  //   }
  // };

// Apply crop and save image
const saveCroppedImage = async () => {
  try {
    if (!cropper) return;

    const selectedResolution =
      CROP_RESOLUTIONS.find((r) => r.id === cropResolutionId) ||
      CROP_RESOLUTIONS[0];

    let canvasOptions = {};
    if (selectedResolution.width && selectedResolution.height) {
      if (cropMode === "fixed") {
        canvasOptions = {
          width: selectedResolution.width,
          height: selectedResolution.height,
        };
      } else {
        const data = cropper.getData(true);
        const ratio = data.width / data.height || 16 / 9;
        canvasOptions = {
          width: selectedResolution.width,
          height: Math.round(selectedResolution.width / ratio),
        };
      }
    }

    const canvas = cropper.getCroppedCanvas(canvasOptions);
    if (!canvas) return;

    const blob = await new Promise((resolve) =>
      canvas.toBlob((b) => resolve(b), "image/jpeg", 0.92)
    );
    if (!blob) return;

    const file = new File([blob], "cropped-image.jpg", {
      type: "image/jpeg",
    });
    const croppedImageUrl = URL.createObjectURL(blob);

    setImagePreview((prev) => {
      // Keep original upload URL intact for re-edit
      if (prev && prev !== originalBannerUrl) revokeIfBlobUrl(prev);
      return croppedImageUrl;
    });
    setBannerImage(file);
    setCropper(null);
    setShowCropper(false);
    setShowCropSettings(false);

  } catch (e) {
    console.error("Error cropping image:", e);
  }
};

  const saveCroppedExtraImage = async () => {
    try {
      const croppedImageUrl = await getCroppedImg(
        extraImages[activeCropIndex].url,
        extraCroppedAreaPixels,
        rotation
      );

      // Convert blob URL to File
      const response = await fetch(croppedImageUrl);
      const blob = await response.blob();
      const file = new File([blob], `extra-cropped-${activeCropIndex}.jpg`, {
        type: "image/jpeg",
      });

      // Replace that extra image
      const updatedImages = [...extraImages];
      updatedImages[activeCropIndex] = { file, url: croppedImageUrl };
      setExtraImages(updatedImages);

      // close cropper
      setActiveCropIndex(null);
    } catch (e) {
      console.error("Error cropping extra image:", e);
    }
  };

  // Cancel cropping
  const cancelCropping = () => {
    setShowCropper(false);
    setImagePreview(null);
  };
  // const handleFileChange = (e) => {
  //   if (e.target.files && e.target.files[0]) {
  //     setBannerImage(e.target.files[0]);
  //   }
  // };


  const quillRef = useRef(null);
  const quillInstance = useRef(null);

 useEffect(() => {
  if (quillRef.current && !quillInstance.current) {
    quillInstance.current = new Quill(quillRef.current, {
      theme: "snow",
      modules: {
        toolbar: [
          [{ size: ["small", false, "large", "huge"] }],
          ["bold", "italic", "underline", "strike"],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link", "image"],
          ["clean"],
        ],
      },
      formats: [
        "size",
        "bold",
        "italic",
        "underline",
        "strike",
        "list",
        "bullet",
        "link",
        "image",
      ],
      placeholder: t("Newsfeed.Write or paste your article content here..."),
    });

    // ✅ Set initial content
    if (description) {
      quillInstance.current.root.innerHTML = description;
    }

    // ✅ Handle content change
    quillInstance.current.on("text-change", (delta, oldDelta, source) => {
      const html = quillInstance.current.root.innerHTML;
      handleArticleChange(html, delta, source, quillInstance.current);
    });
  }
}, []);


  //Image crop closed
  return (
    <>
      {showModal && (
        <Portal layer="modal">
        <div
          className="modal fade show postAdd modal-xl article-xl-modal wlj-overlay-modal"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable article-md-dialog" role="document">
          <div className="articleContainer modal-content">
              <div className="modalBorder setting-header d-flex justify-content-between align-items-center">
                    <div className="AddedNewPostdiv">
                      <h6>{t("Newsfeed.Create an Article")}</h6>
                      <SelectPrivacy
                        className="privacySelect"
                        classNamePrefix="privacySelect"
                        value={Privacy.find(
                          (option) => option.value === privacyType
                        ) || Privacy[0]}
                        onChange={(selectedOption) => {
                          setPrivacyType(selectedOption.value);
                        }}
                        options={Privacy}
                        placeholder={t("Newsfeed.Select Privacy")}
                        styles={privacySelectStyles}
                        isSearchable={false}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        menuShouldScrollIntoView={false}
                        formatOptionLabel={({ label, icon }) => (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {icon}
                            <span style={{ marginLeft: 8 }}>{label}</span>
                          </div>
                        )}
                      />
                    </div>
                    <CloseSharpIcon className="pointer" onClick={closeModal} />
                  </div>
              <form className="HuzaifaAddArticleForm" onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-12">
                    <label className="form-label fw-medium">
                      {t("Newsfeed.Banner Image")}
                      <span className="text-danger ms-1">*</span>
                    </label>
                        {/* 2️⃣ If we have preview (but not cropping) */}

                        <div className="Inside-image-container">
                          {imagePreview && !showCropper && (
                            <div className="preview-container text-center position-relative d-inline-block">
                              {/* ✅ Close (X) button in corner */}
                              <button
                                type="button"
                                onClick={() => {
                                  setImagePreview((prev) => {
                                    if (prev && prev !== originalBannerUrl) {
                                      revokeIfBlobUrl(prev);
                                    }
                                    return null;
                                  });
                                  revokeIfBlobUrl(originalBannerUrl);
                                  setOriginalBannerUrl(null);
                                  setBannerImage(null);
                                  setCropper(null);
                                  setShowCropper(false);
                                }}
                                style={{
                                  position: "absolute",
                                  top: "8px",
                                  right: "8px",
                                  backgroundColor: "rgba(0,0,0,0.6)",
                                  border: "none",
                                  color: "white",
                                  fontSize: "20px",
                                  fontWeight: "bold",
                                  borderRadius: "50%",
                                  width: "32px",
                                  height: "32px",
                                  lineHeight: "28px",
                                  cursor: "pointer",
                                }}
                              >
                                ×
                              </button>


                              {/* Preview Image */}
                              <img
                                src={imagePreview}
                                alt="Preview"
                                className="img-fluid mb-3 rounded"
                                style={{ maxHeight: "300px" }}
                              />

                              {/* Crop button below */}
                              <div className="old-button-area d-flex justify-content-center gap-2">
                                {/* <button
                                  type="button"
                                  className="btn btn-sm btn-outline-primary"
                                  onClick={() => setShowCropper(true)}
                                > */}
                                  {/* {t("Newsfeed.Crop")} */}
                                  <span
                                    className="  pointer"
                                    style={{ backgroundColor: "gainsboro", padding: "7px 10px 10px 10px", borderRadius: "50%" }}
                                    onClick={openBannerCropper}
                                     
                                    >

                                    <EditSharpIcon   className="material-symbols-sharp" />
                                    </span>
                                
                                {/* </button> */}

                                {/* Add Image button */}
                                {/* <button
                                  type="button"
                                  className="btn btn-sm btn-outline-success"
                                  onClick={() => document.getElementById("addNewImage").click()}
                                >
                                  {t("Newsfeed.Add Image")}
                                </button> */}
                                <input
                                  id="addNewImage"
                                  type="file"
                                  className="d-none"
                                  accept="image/*"
                                  onChange={handleAddNewImage}
                                />
                              </div>
                            </div>
                          )}

                          {/* New Image add karna ke liya function h yeh */}
                          {extraImages.length > 0 && activeCropIndex !== 0 && (
                            <div className="Extranew-Image-area">
                              {extraImages.map((img, index) => (
                                <div
                                  key={index}
                                  className="preview-container text-center position-relative d-inline-block Extranew-personal-img"
                                >
                                  {/* Close button */}
                                  <button
                                    type="button"
                                    onClick={() =>
                                      setExtraImages(extraImages.filter((_, i) => i !== index))
                                    }
                                    style={{
                                      position: "absolute",
                                      top: "8px",
                                      right: "8px",
                                      backgroundColor: "rgba(0,0,0,0.6)",
                                      border: "none",
                                      color: "white",
                                      fontSize: "20px",
                                      fontWeight: "bold",
                                      borderRadius: "50%",
                                      width: "32px",
                                      height: "32px",
                                      lineHeight: "28px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    ×
                                  </button>

                                  {/* Preview Image */}
                                  <img
                                    src={img.url}
                                    alt={`Extra ${index}`}
                                    className="img-fluid mb-3 rounded"
                                    style={{ maxHeight: "300px" }}
                                  />

                                  {/* ✅ Crop button for this image */}
                                  <div className="new-button-area ">
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-primary"
                                      onClick={() => setActiveCropIndex(index)}
                                    >
                                      {t("Newsfeed.Crop")}
                                    </button>

                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-success"
                                      onClick={() => document.getElementById("addNewImage").click()}
                                    >
                                      {t("Newsfeed.Add Image")}
                                    </button>
                                    <input
                                      id="addNewImage"
                                      type="file"
                                      className="d-none"
                                      accept="image/*"
                                      onChange={handleAddNewImage}
                                    />
                                  </div>

                                  {/* Add Image button */}

                                </div>
                              ))}
                            </div>
                          )}
                        </div>


                        {/* If we are in cropper mode   Old and New both  START*/}
                        {showCropper && (
                          <div className="bg-white rounded shadow-sm p-3">
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <h6 className="mb-0">{t("Newsfeed.Crop Your Image")}</h6>
                              <span
                                className="pointer"
                                style={{
                                  backgroundColor: "gainsboro",
                                  padding: "7px 10px 10px 10px",
                                  borderRadius: "50%",
                                }}
                                onClick={() => setShowCropSettings((prev) => !prev)}
                                title={t("Newsfeed.Crop Settings")}
                              >
                                <EditSharpIcon className="material-symbols-sharp" />
                              </span>
                            </div>

                            {showCropSettings && (
                              <div className="border rounded p-3 mb-3 bg-light">
                                <div className="mb-3">
                                  <label className="form-label small fw-medium mb-1">
                                    {t("Newsfeed.Crop Mode")}
                                  </label>
                                  <div className="d-flex gap-2">
                                    <button
                                      type="button"
                                      className={
                                        cropMode === "fixed"
                                          ? "mainBtn1"
                                          : "btn btn-sm btn-outline-secondary"
                                      }
                                      onClick={() => setCropMode("fixed")}
                                    >
                                      {t("Newsfeed.Fixed")}
                                    </button>
                                    <button
                                      type="button"
                                      className={
                                        cropMode === "auto"
                                          ? "mainBtn1"
                                          : "btn btn-sm btn-outline-secondary"
                                      }
                                      onClick={() => setCropMode("auto")}
                                    >
                                      {t("Newsfeed.Auto")}
                                    </button>
                                  </div>
                                </div>
                                <div>
                                  <label className="form-label small fw-medium mb-1">
                                    {t("Newsfeed.Resolution")}
                                  </label>
                                  <select
                                    className="form-select form-select-sm"
                                    value={cropResolutionId}
                                    onChange={(e) => setCropResolutionId(e.target.value)}
                                  >
                                    {CROP_RESOLUTIONS.map((res) => (
                                      <option key={res.id} value={res.id}>
                                        {res.id === "original"
                                          ? t("Newsfeed.Original")
                                          : res.label}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            )}

                            <div
                              style={{
                                position: "relative",
                                height: "240px",
                                background: "#f0f0f0",
                              }}
                              className="mb-3"
                            >
                              <Cropper
                                  key={cropperKey}
                                  src={originalBannerUrl || imagePreview}
                                  style={{ height: 240, width: "100%" }}
                                  aspectRatio={cropMode === "fixed" ? 16 / 9 : NaN}
                                  guides={true}
                                  viewMode={1}
                                  dragMode="move"
                                  cropBoxResizable={true}
                                  cropBoxMovable={true}
                                  background={false}
                                  responsive={true}
                                  autoCropArea={1}
                                  checkOrientation={false}
                                  onInitialized={(instance) => {
                                    setCropper(instance);
                                  }}
                                />
                            </div>

                            <div className="d-flex justify-content-end gap-2">
                              <button
                                type="button"
                                className="closebtn"
                                onClick={() => {
                                  setShowCropper(false);
                                  setShowCropSettings(false);
                                }}
                              >
                                {t("Connections.Cancel")}
                              </button>
                              <button
                                type="button"
                                className="mainBtn1"
                                onClick={saveCroppedImage}
                              >
                                {t("Newsfeed.Apply Crop")}
                              </button>
                            </div>
                          </div>
                        )}


                        {activeCropIndex !== null && (
                          <div className="bg-white rounded shadow-sm p-3">
                            <h6 className="mb-3">{t("Newsfeed.Crop Extra Image")} </h6>
                            <div
                              style={{
                                position: "relative",
                                height: "240px",
                                background: "#f0f0f0",
                              }}
                              className="mb-3"
                            >
                              <Cropper
                                image={extraImages[activeCropIndex].url}
                                crop={crop}
                                zoom={zoom}
                                aspect={16 / 9}
                                onCropChange={setCrop}
                                onCropComplete={onCropComplete}
                                onZoomChange={setZoom}
                                rotation={rotation}
                              />
                            </div>

                            <div className="d-flex justify-content-end gap-2">
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() => setActiveCropIndex(null)}
                              >
                                {t("Connections.Cancel")}
                              </button>
                              <button
                                type="button"
                                className="btn btn-sm btn-primary"
                                onClick={saveCroppedExtraImage}
                              >
                                {t("Newsfeed.Apply Crop")}
                              </button>
                            </div>
                          </div>
                        )}
                        {/* If we are in cropper mode   Old and New both  END*/}



                        {/* 3️⃣ If no image uploaded */}
                        {!imagePreview && !showCropper && extraImages.length === 0 && (
                          <div className="card rounded-0">
                            <div className="card-body Article-body">
                              <div className="custom-file-upload text-center p-2">
                                {/* <div className="upload-icon mb-3"> ...your svg... </div> */}
                                <p className="mb-3">
                                  {t("Newsfeed.We recommend uploading or dragging in an image that is 1920x1080 pixels")}

                                </p>
                                <button
                                  className="mainBtn"
                                  type="button"
                                  onClick={() => document.getElementById("fileUpload").click()}
                                >
                                  {t("Newsfeed.Upload from file")}
                                </button>
                                <input
                                  id="fileUpload"
                                  type="file"
                                  className="d-none"
                                  accept="image/*"
                                  onChange={handleFileChange}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                        {display && (!bannerImage || bannerImage === "") && (
                          <span className="error_msg_lbl"> {t("Newsfeed.Please upload a banner image")} </span>
                        )}
                  </div>

                  <div className="col-12 col-md-6 article-title-col">
                    <label className="form-label fw-medium">
                      {t("Newsfeed.Title")}
                      <span className="text-danger ms-1">*</span>
                      <span className="field-hint text-danger ms-1">
                        {t("Newsfeed.Special characters not allowed", {
                          defaultValue: "Special characters not allowed",
                        })}
                      </span>
                    </label>
                    <div className="input-wrapper">
                      <input
                        type="text"
                        className="form-control HuzTitleInput"
                        placeholder={t("Newsfeed.Enter article title")}
                        value={title}
                        onChange={handleTitleChange}
                        // required
                        invalid={display && title.trim() === ""}

                      />
                    </div>
                    {display && title.trim() === "" && (
                      <span className="error_msg_lbl">{t("Newsfeed.Enter article title")}</span>
                    )}
                  </div>

                  <div className="col-12 col-md-6 article-tags-col">
                    <label className="form-label fw-medium">{t("Newsfeed.Tags")}<span className="text-danger ms-1">*</span>
                    </label>
                    <div className="input-wrapper">
                    <Select
                      mode="tags"
                      className="ArticleHuzTagColor HuzTagselectInner"
                      style={{ width: "100%" }}
                      placeholder={t("Newsfeed.Enter Tags")}
                      onChange={handleTagChange}
                      value={selectedTags}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      dropdownStyle={{
                        position: "fixed",
                      }}
                    >
                      {tagOptions?.map((tag) => (
                        <Select.Option key={tag?.atmid} value={tag?.tagName}>
                          {/* {tag?.tagName} */}
                            {tag?.tagName.replace(/[\[\]"\\]/g, "").trim()}   
                        </Select.Option>
                      ))}
                    </Select>
                    </div>
                    {display && (!selectedTags || selectedTags.length === 0) && (
                      <span className="error_msg_lbl ArticleHuzTagColor">{t("Newsfeed.Enter Tags")}</span>
                    )}
                  </div>

                  {/* <div className="col-12 mb-4">
                    <label className="form-label fw-medium">Content *</label>
                    <ReactQuill
                      ref={editorRef}
                      value={description}
                      onChange={(content, delta, source, editor) => {
                        handleArticleChange(content, delta, source, editor);
                      }}
                      modules={modules}
                      formats={formats}
                      theme="snow"
                      className="form-quill"
                      placeholder={t("Newsfeed.Write or paste your article content here...")}
                    /> 
                    {showSuggestions && (
                      <ul className="suggestion-box">
                        {mentionType === "Hashtag" ? <li
                          onMouseDown={(e) => {
                            e.preventDefault(); // Prevent editor blur
                            insertMention(
                              SearchText,
                              null
                            );
                          }}
                          className="suggestion-item"
                        >
                          <span>{SearchText ? `#${SearchText}` : ''}</span>
                        </li> : null}
                        {suggestions?.map((item, index) => (
                          <li
                            key={index}
                            onMouseDown={(e) => {
                              e.preventDefault();
                              insertMention(
                                mentionType === "UserMention"
                                  ? item?.entityName
                                  : item?.hashTag,
                                mentionType === "UserMention"
                                  ? item?.userUid
                                  : null
                              );
                            }}
                            className="suggestion-item"
                          >
                            {mentionType === "UserMention" ? (
                              <>
                                <img
                                  src={item?.avatar}
                                  alt={item?.entityName}
                                  className="avatar"
                                />
                                <span>{item?.entityName}</span>
                              </>
                            ) : (
                              <span>#{item?.hashTag}</span>
                            )}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div> */}
                  <div className="col-12">
                    <label className="form-label fw-medium">{t("Newsfeed.Content")}<span className="text-danger ms-1">*</span>
                    </label>

                    <div
                      ref={quillRef}
                      value={description}
                      className="form-quill content-textarea AddArticleNewQuill"
                      // style={{ minHeight: "250px", backgroundColor: "#fff" }}
                    ></div>

                    {showSuggestions && (
                      <ul className="suggestion-box">
                        {mentionType === "Hashtag" && (
                          <li
                            onMouseDown={(e) => {
                              e.preventDefault();
                              insertMention(SearchText, null);
                            }}
                            className="suggestion-item"
                          >
                            <span>{SearchText ? `#${SearchText}` : ""}</span>
                          </li>
                        )}
                        {suggestions?.map((item, index) => (
                          <li
                            key={index}
                            onMouseDown={(e) => {
                              e.preventDefault();
                              insertMention(
                                mentionType === "UserMention" ? item?.entityName : item?.hashTag,
                                mentionType === "UserMention" ? item?.userUid : null
                              );
                            }}
                            className="suggestion-item"
                          >
                            {mentionType === "UserMention" ? (
                              <>
                                <img src={item?.avatar} alt={item?.entityName} className="avatar" />
                                <span>{item?.entityName}</span>
                              </>
                            ) : (
                              <span>#{item?.hashTag}</span>
                            )}
                          </li>
                        ))}
                      </ul>
                    )}

                    {/* {display && (!postInputValue || postInputValue.trim() === "") && (
                      <span className="error_msg_lbl">{t("Newsfeed.Please enter content")}</span>
                    )} */}
                  </div>
                </div>
                  <div className="article-modal-footer d-flex justify-content-end">
                    <button
                      className="mainBtn"
                      type="submit"
                      disabled={isloading}
                    >
                      {isloading === true ? t("Newsfeed.Posting") : t("Newsfeed.Post Article")}
                    </button>
                  </div>
              </form>
          </div>
          </div>
        </div>
        </Portal>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default AddArticle;
